<template>
  <div class="controlPubilcCom">
    <div class="topData ashComWrap">
      <div class="comTitle">
        <h4>{{ treeActive.name }}</h4>
      </div>
      <div class="comContentBox">
        <CardList
          :assetsTitle="treeActive.name"
          :listData="listData"
          @changeSwitch="changeSwitch"
          :showDownload="controlPermissions"
        />
      </div>
    </div>
    <div class="btnBox">
      <el-radio-group
        v-if="treeActive.systemName == '风机盘管,分体式空调'"
        v-model="changingOver"
        size="small"
        style="margin-right: 20px"
        @change="getDetailsList"
      >
        <el-radio-button label="风机盘管">中央空调末端</el-radio-button>
        <!-- <el-radio-button label="分体式空调">分体空调末端</el-radio-button> -->
      </el-radio-group>
      <el-button icon="el-icon-refresh" size="small" @click="handleData"
        >刷新</el-button
      >
      <el-button
        size="small"
        v-if="
          treeActive.systemName == '风机盘管,分体式空调' &&
          !treeActive.children?.length
        "
        @click="dialogVisible = true"
        >一键控温</el-button
      >
    </div>
    <div class="bottomBox" ref="controlWrap">
      <template
        v-if="
          treeActive.systemName == '风机盘管,分体式空调' &&
          !treeActive.children?.length
        "
      >
        <AirControl :tableList="tableList" @changeState="changeState" />
      </template>
      <!-- 照明系统-系统控制-设备 -->
      <template
        v-else-if="
          treeActive.systemName == '照明设备' && !treeActive.children?.length
        "
      >
        <div class="equipmentControlItem" v-for="(v, i) in tableList" :key="i">
          <el-tooltip
            class="item"
            effect="dark"
            :content="v.name"
            placement="top-start"
            :disabled="v.name?.length < 20"
          >
            <h4>{{ v.name }}</h4>
          </el-tooltip>

          <div class="switchWrap">
            <el-switch
              :disabled="!controlPermissions"
              :value="v.isOpen"
              @change="
                changeState({
                  entityId: v.entityId,
                  isOpen: v.isOpen ? 'OFF' : 'ON',
                  key: 'RunSign',
                })
              "
            >
            </el-switch>
          </div>
          <div class="stateWrap">
            <img
              :src="
                require(`@/assets/images/xitong/${
                  v.active ? 'deviceOnline' : 'deviceOffline'
                }.png`)
              "
            />
          </div>
        </div>
      </template>
      <template v-else>
        <div class="controlItem" v-for="(v, i) in tableList" :key="i">
          <div class="title">
            <el-tooltip
              class="item"
              effect="dark"
              :content="v.name"
              placement="top-start"
              :disabled="v.name?.length < 10"
            >
              <h4 @click="getClickTitle(v)">{{ v.name }}</h4>
            </el-tooltip>

            <p class="rowP">
              总数 <span>{{ v.allSize }}个</span>
            </p>
            <p class="rowP">
              开启 <span style="color: #28cccb">{{ v.openSize }}个</span>
            </p>
          </div>
          <div
            class="switchBox"
            :style="{
              justifyContent:
                v.entityType == 'ASSET' ? 'space-around' : 'flex-end',
            }"
          >
            <template v-if="v.entityType == 'ASSET'">
              <el-button
                :disabled="!controlPermissions"
                size="mini"
                @click="
                  changeSwitch({
                    name: v.name,
                    entityId: v.entityId,
                    isOpen: 'OFF',
                    key: 'RunSign',
                  })
                "
                >全关</el-button
              >
              <el-button
                :disabled="!controlPermissions"
                type="primary"
                size="mini"
                @click="
                  changeSwitch({
                    name: v.name,
                    entityId: v.entityId,
                    isOpen: 'ON',
                    key: 'RunSign',
                  })
                "
                >全开</el-button
              >
            </template>
          </div>
        </div>
      </template>
    </div>
    <!-- 一键控温 -->
    <TempControlDialog v-if="dialogVisible" :treeActive="treeActive" />
  </div>
</template>

<script>
import api from "@/api";
import CardList from "@/components/zixitong/CardList";
import AirControl from "@/components/zixitong/airSystem/AirControl";
import { judgeAuthority } from "@/assets/js/utils";
import TempControlDialog from "@/components/zixitong/airSystem/control/TempControlDialog.vue";
export default {
  props: {
    treeActive: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    CardList,
    AirControl,
    TempControlDialog,
  },
  data() {
    return {
      listData: [],
      changingOver: "风机盘管",
      tableList: [],
      controlPermissions: false,
      dialogVisible: false,
    };
  },
  methods: {
    judgeAuthority,
    handleData() {
      this.getListData();
      this.getDetailsList();
    },
    changeSwitch(data) {
      this.$confirm(
        `该操作将${data.isOpen == "ON" ? "开启" : "关闭"}${data.name}内所有${
          this.$route.path == "/console" ? "照明开关" : "风机盘管/分体式空调"
        }，请确认是否执行此操作？`,
        "提示",
        {
          confirmButtonText: "执行",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.changeState(data);
        })
        .catch(() => {});
    },

    async changeState(data) {
      this.$store.commit("SET_LOADING", true);
      let params = {
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        entityId: data.entityId ? data.entityId : this.treeActive.id,
        modular: "开关",
        type:
          this.treeActive.systemName == "照明设备"
            ? "照明设备"
            : this.changingOver,
        controlType: data.isOpen,
        key: data.key,
      };
      let obj = Object.assign({}, params, { value: data.value });

      let res = await api.subsystemControlSwitch(
        data.key == "RunSign" ? params : obj
      );
      if (res && res.data.code == 200) {
        setTimeout(() => {
          this.$message.success("操作成功");
          this.handleData();
          this.$store.commit("SET_LOADING", false);
        }, 2000);
      } else {
        this.$store.commit("SET_LOADING", false);
      }
    },
    async getListData() {
      this.listData = [];
      let res = await api.subsystemAllGetList({
        assetId: this.treeActive.id,
        modular: "开关",
        type: this.treeActive.systemName,
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
      });
      if (res?.data.code == 200) {
        this.listData = res.data.data.list.filter((v) => {
          return v.name !== "额定功率" && v.name !== "实时功率";
        });
        this.listData.map((v) => {
          if (v.value >= 10000) {
            v.value = (v.value / 10000).toFixed(2);
            v.unit = "万" + v.unit;
          }
        });
      }
    },
    async getDetailsList() {
      this.tableList = [];
      this.$refs.controlWrap.scrollTop = 0;
      let res = await api.subsystemAllDetailsList({
        assetId: this.treeActive.id,
        modular: "开关",
        type:
          this.treeActive.systemName == "照明设备"
            ? "照明设备"
            : this.changingOver,
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        label: "区域位置",
        pageSize: 10000,
        page: 0,
      });
      if (res?.data.code == 200) {
        this.tableList = res.data.data.data;
        if (
          this.treeActive.systemName !== "照明设备" &&
          !this.treeActive.children?.length
        ) {
          this.tableList.map((v) => {
            v.SetTemperature = v.SetTemperature
              ? parseInt(v.SetTemperature)
              : 16;
            v.SetAirVolume = v.SetAirVolume ? parseInt(v.SetAirVolume) : 10;
            v.temp = v.SetTemperature + "℃";
            v.orderNum = v.temp.split("");
          });
        }
      }
    },

    getClickTitle(item) {
      this.$bus.$emit("getClickAssetsItem", item);
    },
  },
  created() {
    this.controlPermissions = judgeAuthority(
      this.$route.path == "/console"
        ? "zixitong:zhaoming:console:edit"
        : "zixitong:kongtiao:controls:edit"
    );
  },
};
</script>

<style lang="scss" scoped>
.controlPubilcCom {
  @include setCenterWH;
  .topData {
    width: 100%;
    height: 18%;
  }
  .btnBox {
    margin: 12px 0;
  }
  .bottomBox {
    width: 100%;
    height: 75%;
    overflow: auto;
    .controlItem {
      width: 200px;
      background: #fff;
      border-radius: 6px;
      margin: 0 10px 10px 0;
      display: inline-block;
      .title {
        width: calc(100% - 40px);
        margin: 0 auto;
        border-bottom: 1px solid #eaeaea;

        h4 {
          font-size: 14px;
          padding: 10px 0;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          cursor: pointer;
          &:hover {
            color: #53d6d5;
          }
        }
        p {
          margin-bottom: 10px;
          color: #666;
          span {
            margin-left: 10px;
            font-weight: bold;
          }
        }
      }
      .switchBox {
        width: calc(100% - 40px);
        margin: 10px auto;
        @include setFlexAround;
      }
    }
    .equipmentControlItem {
      width: 400px;
      height: 126px;
      background: #fff;
      border-radius: 6px;
      margin: 0 12px 12px 0;
      display: inline-block;
      position: relative;
      overflow: hidden;
      h4 {
        width: calc(100% - 32px);
        margin: 0 auto;
        font-size: 14px;
        padding: 12px 0;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .switchWrap {
        position: absolute;
        bottom: 15px;
        left: 20px;
      }
      .stateWrap {
        position: absolute;
        right: -13px;
        bottom: -20px;
      }
    }
  }
}
</style>
